<template>
  <div class="content ">
    <div class="container-fluid">
      <div class="row">

        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">



            <template slot="header">

              <div class="row">
                <div class="col-10">
                  <h4 class="card-title">Raporlar</h4>
                  <p class="card-category">Sistemi Güncel tutmak için, haftalık raporu düzenli olarak tutmalısınız.</p>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-success btn-fill float-right mr-3" @click="uploadReportModal()">
                    Rapor Yükleyin
                  </button>
                </div>

              </div>


            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(report, index) in reports" :key="report._id">
                  <slot :row="report">
                    <td>{{ report.title }}</td>
                    <td>{{ report.dealer.title }}</td>
                    <td>{{ statusMap[report.status] }}</td>
                    <td v-if="report.status == 'PENDING'" @click="startReportProcess(report)"><button><i
                          class="nc-icon nc-button-play"></i></button></td>
                    <td v-if="report.status == 'IN_PROGRESS'" @click="stopReportProcess(report)"><button><i
                          class="nc-icon nc-button-pause"></i></button></td>
                    <td v-if="report.status == 'COMPLETED'">Rapor İşlendi.</td>
                    <td @click="openDeleteModal(report)"><button><i class="nc-icon nc-simple-remove"></i></button>
                    </td>
                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)" :key="i"><a
                    class="page-link">{{ i + 1 }}</a></li>



              </ul>
            </nav>
          </card>

        </div>


        <div class="modal fade show bg-gray" tabindex="-1"
          :style="deleteModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
          <div class="modal-dialog" v-if="deleteModal.report">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLiveLabel">Raporu silmek istediğinize emin misiniz? Rapor ile
                  ilgili tüm
                  veriler silinecektir.</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                  @click="openDeleteModal(null)">
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div class="modal-body">
                <label><strong>Rapor Adı:</strong> {{ deleteModal.report.title }}</label><br>
                <label><strong>Bayii Adı:</strong> {{ deleteModal.report.dealer.title }}</label><br>

              </div>
              <div class="modal-footer">

                <button type="button" @click="openDeleteModal(null)" class="btn btn-secondary"
                  data-dismiss="modal">Kapat</button>
                <button type="button" @click="deleteReport(deleteModal.report)" class="btn btn-primary">Sil!</button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade show bg-gray" tabindex="-1"
          :style="uploadModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
          <div class="modal-dialog" v-if="uploadModal.isOpened">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLiveLabel">Haftalık Bayii Raporu Yükle</h5>



              </div>

              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">

                    <div class="alert alert-warning">
                      Rapor dosyasının ismini kesinlikle değiştirmeyiniz. Bayii portalından indirildiği ismi ile
                      sisteme
                      yüklenmelidir.
                    </div>


                    <div class="file-upload">
                      <input type="file" class="file-input" id="reportFile" accept=".xlsx"
                        :disabled="uploadModal.loading" @change="uploadFile($event)" style="display: none">
                      <label for="reportFile" class="btn btn-outline-secondary">
                        Rapor Dosyasını Seçiniz
                      </label>
                      <span class="file-name ml-2">
                        <br>
                        {{ uploadModal.file ? `Seçilen Dosya: ${uploadModal.file.name}` : 'Dosya seçilmedi' }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-if="uploadModal.error" class="alert alert-danger mt-3">
                  {{ uploadModal.error }}
                </div>
              </div>


              <div class="modal-footer">
                <button type="button" @click="closeUploadModal()" class="btn btn-secondary"
                  data-dismiss="modal">Kapat</button>
                <button type="button" @click="uploadReport()" class="btn btn-primary">Yükle</button>
              </div>

            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";
const statusMap = {
  'UPLOADING': 'Yükleniyor',
  'PENDING': 'İşlenmeye Hazır',
  'IN_PROGRESS': 'İşleniyor...',
  'COMPLETED': 'İşlem Tamamlandı'
}


const tableColumns = ['Rapor Adı', 'Bayii', 'Durum', 'Aksiyon', 'Sil']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      statusMap,
      reports: [],
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
      queryText: '',
      deleteModal: {
        isOpened: false,
        report: null
      },
      uploadModal: {
        isOpened: false,
        file: undefined,
        dealer: "-1",
        loading: false,
        error: null
      },
      searchInterval: null
    }
  },
  mounted() {
    this.getReports();
    setTimeout(() => {
      setInterval(() => {
        if (this.uploadModal.loading == false && this.uploadModal.isOpened == false) {
          this.getReports();
        }
      }, 10000);
    }, 1000);
  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getReports();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getReports() {
      let q = {};
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('report', query).then((res) => {
        if (res.success == true) {
          this.reports = res.reports;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {
          console.log('error');
        }
      })
    },
    deleteReport(report) {
      CollectionService.deleteItem('report', report._id).then((res) => {
        this.notifyVue('bottom', 'right', 'danger', ` ${report.title} rapor silindi. Rapor ile ilgili tüm veriler silindi.`)
        this.deleteModal.isOpened = false;
        this.deleteModal.report = null;
        this.getReports();
      }).catch((err) => {
        this.notifyVue('bottom', 'right', 'danger', ` ${report.title} rapor silinirken bir hata oluştu.`)
        this.deleteModal.isOpened = false;
        this.deleteModal.report = null;
      })
    },
    startReportProcess(report) {
      CollectionService.getCollectionItemWithId('report/startprocess', report._id).then((res) => {
        this.notifyVue('bottom', 'right', 'success', ` ${report.title} rapor işlenmeye başlandı.`)
        this.getReports();

        setTimeout(() => {
          this.getReports();
        }, 10000);
      })
    },
    stopReportProcess(report) {
      CollectionService.getCollectionItemWithId('report/stopprocess', report._id).then((res) => {
        this.notifyVue('bottom', 'right', 'success', ` ${report.title} rapor işlenme durduruldu.`)
        this.getReports();
      })
    },
    openDeleteModal(report) {
      this.deleteModal.isOpened = !this.deleteModal.isOpened
      this.deleteModal.report = report;
    },
    editReport(_id) {
      this.$router.push(`/admin/reports/${_id}`);
    },
    uploadReportModal() {
      this.uploadModal.isOpened = true;
      this.uploadModal.file = undefined;
      this.uploadModal.loading = false;
      this.uploadModal.error = null;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    uploadFile(event) {
      const file = event.target.files[0];
      console.log(file);
      if (file) {
        this.uploadModal.file = file;
        this.uploadModal.error = null;
      }
    },
    async uploadReport() {
      if (!this.uploadModal.isOpened) {
        this.uploadModal.isOpened = true;
        return;
      }

      if (!this.uploadModal.file) {
        this.uploadModal.error = 'Lütfen bir dosya seçin';
        return;
      }


      try {
        this.uploadModal.loading = true;

        const formData = new FormData();
        formData.append('file', this.uploadModal.file);

        const response = await CollectionService.uploadReport(formData);
        console.log(response);

        if (response.success) {
          this.notifyVue('bottom', 'right', 'success', 'Rapor başarıyla yüklendi');
          this.getReports();
          this.closeUploadModal();
        } else {
          throw new Error(response.message || 'Yükleme başarısız');
        }
      } catch (error) {
        if (error.includes('<title>Error</title>')) {
          this.uploadModal.error = error.match(/<pre>(.*)<\/pre>/)[1];
        } else {
          let errorJson = JSON.parse(error);
          this.uploadModal.error = JSON.stringify(errorJson.message);
        }

        this.notifyVue('bottom', 'right', 'danger', 'Rapor yüklenirken hata oluştu + ' + this.uploadModal.error);
      } finally {
        this.uploadModal.loading = false;
      }
    },
    closeUploadModal() {
      console.log('closeUploadModal');
      this.uploadModal = {
        isOpened: false,
        file: undefined,
        dealer: "-1",
        loading: false,
        error: null
      };
    }
  }
}
</script>
<style></style>